import { getMapLayerById } from "../utils/mapUtils";
import { transform, fromLonLat } from "ol/proj";
import { Point, LineString } from "ol/geom.js";
import Feature from "ol/Feature.js";
import { inAndOut } from "ol/easing";
import { Style, Fill, Stroke, Circle as CircleStyle } from "ol/style";
import Geolocation from "ol/Geolocation.js";
import { circular } from "ol/geom/Polygon";

export const GetCurrentGPSLocation = (map, mode) => {
    const gpsLayer = getMapLayerById(map, "gpsLayer");
    const gpsLayerTrack = getMapLayerById(map, "gpsLayerTrack");
    if (mode === "off") {
        gpsLayer.getSource().clear(true);
        gpsLayerTrack.getSource().clear(true);
    } else {
        navigator.geolocation.getCurrentPosition(
            function (pos) {
                const coords = [pos.coords.longitude, pos.coords.latitude];
                const accuracy = circular(coords, pos.coords.accuracy);
                gpsLayer.getSource().clear(true);
                let accuracyHalo = new Feature(
                    accuracy.transform("EPSG:4326", map.getView().getProjection())
                );
                let projCoor = fromLonLat(coords, map.getView().getProjection());
                let point = new Feature(new Point(projCoor));

                point.setStyle(
                    new Style({
                        fill: new Fill({
                            color: "rgb(98, 158, 211)",
                        }),
                        stroke: new Stroke({
                            color: "rgb(98, 158, 211)",
                            width: 2,
                        }),
                        image: new CircleStyle({
                            radius: 5,
                            fill: new Fill({
                                color: "rgb(98, 158, 211)",
                            }),
                        }),
                    })
                );

                gpsLayer.getSource().addFeatures([accuracyHalo, point]);

                //Check if map is zoom in to close then out to the Desired min scale current hard coded at 1 inch = 400 feet
                let currentres = map.getView().getResolution();
                let minResolution = 400 / 96 / 12; // {Desired Min Map Scale } / {DPI} / {inches in feet}
                if (currentres < minResolution) {
                    map.getView().setResolution(minResolution);
                }
                //recenter map on gps
                map.getView().animate({
                    duration: 750,
                    easing: inAndOut,
                    center: projCoor,
                });

                if (mode === "track") {
                    if (gpsLayerTrack.getSource().getFeatures().length === 0) {
                        let line = new Feature(new LineString([projCoor, projCoor]));
                        gpsLayerTrack.getSource().addFeature(line);
                    } else {
                        gpsLayerTrack
                            .getSource()
                            .getFeatures()[0]
                            .getGeometry()
                            .appendCoordinate(projCoor);
                    }
                    //console.log(gpsLayerTrack.getSource().getFeatures()[0].getGeometry().getCoordinates());
                }
            },
            function (error) {
                console.log(`ERROR: ${error.message}`);
            },
            {
                enableHighAccuracy: true,
                maximumAge: 500,
                timeout: 1000,
            }
        );
    }
};

export const PlotTrimbleData = (map, data) => {
    const gpsLayer = getMapLayerById(map, "gpsLayer");
    const gpsLayerTrack = getMapLayerById(map, "gpsLayerTrack");

    const coords = [data.longitude, data.latitude];
    const accuracy = circular(coords, data.accuracy);
    gpsLayer.getSource().clear(true);
    let accuracyHalo = new Feature(
        accuracy.transform("EPSG:4326", map.getView().getProjection())
    );
    let projCoor = fromLonLat(coords, map.getView().getProjection());
    let point = new Feature(new Point(projCoor));
    //Check if map is zoom in to close then out to the Desired min scale current hard coded at 1 inch = 400 feet
    let currentres = map.getView().getResolution();
    let minResolution = 400 / 96 / 12; // {Desired Min Map Scale } / {DPI} / {inches in feet}
    if (currentres < minResolution) {
        map.getView().setResolution(minResolution);
    }
    //recenter map on gps
    map.getView().animate({
        duration: 750,
        easing: inAndOut,
        center: projCoor,
    });
    point.setStyle(
        new Style({
            fill: new Fill({
                color: "rgb(255, 0, 211)",
            }),
            stroke: new Stroke({
                color: "rgb(255, 158, 211)",
                width: 2,
            }),
            image: new CircleStyle({
                radius: 5,
                fill: new Fill({
                    color: "rgb(255, 0, 211)",
                }),
            }),
        })
    );

    gpsLayer.getSource().addFeatures([accuracyHalo, point]);

    if (gpsLayerTrack.getSource().getFeatures().length === 0) {
        let line = new Feature(new LineString([projCoor, projCoor]));
        gpsLayerTrack.getSource().addFeature(line);
    } else {
        gpsLayerTrack
            .getSource()
            .getFeatures()[0]
            .getGeometry()
            .appendCoordinate(projCoor);
    }
};

//Returns coord in map units and average accuray in meters
export const GetAveragedGPSLocation = (map, numOfReading, readingInterval) => {
    let coorArr = [];
    for (let index = 0; index < numOfReading; index++) {
        navigator.geolocation.getCurrentPosition(
            function (pos) {
                const coords = [
                    pos.coords.longitude,
                    pos.coords.latitude,
                    pos.coords.altitude,
                ];
                const accuracy = pos.coords.accuracy;

                let projCoor = fromLonLat(coords, map.getView().getProjection());
                coorArr.push({
                    x: projCoor.latitude,
                    y: projCoor.longitude,
                    z: projCoor.altitude,
                    accXY: pos.coords.accuracy,
                    accZ: pos.coords.altitudeAccuracy,
                });
            },
            function (error) {
                console.log(`ERROR: ${error.message}`);
            },
            {
                enableHighAccuracy: true,
                maximumAge: 0,
                timeout: readingInterval,
            }
        );
    }
};
